import BASE_URL from "../config";

const json = async (response) => {
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

const net = { ok: false, status: 0, success: false, message: "Network error - please try again." };

// Public: the "Mobile Number Customization Form".
export const submitMobileNumberRequest = async (payload) => {
  try {
    return json(
      await fetch(`${BASE_URL}/mobile-number-requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
    );
  } catch {
    return net;
  }
};

/* ----------------------------------------------------------------- admin */

export const adminGetMobileNumberRequests = async ({ page = 1, limit = 20, status = "", search = "" }, token) => {
  const qs = new URLSearchParams({ page, limit });
  if (status) qs.set("status", status);
  if (search) qs.set("search", search);
  try {
    return json(await fetch(`${BASE_URL}/mobile-number-requests?${qs}`, { headers: { Authorization: `Bearer ${token}` } }));
  } catch {
    return net;
  }
};

export const adminUpdateMobileNumberRequest = async (id, payload, token) => {
  try {
    return json(
      await fetch(`${BASE_URL}/mobile-number-requests/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      })
    );
  } catch {
    return net;
  }
};
